import { getDealers } from '@utils/helpers'
import { useEffect, useState } from 'react'

import { SelectInput } from '../baseInputs'

type Props = {
  helper?: string
  optional?: boolean
  label?: string
}

const Dealers = ({ helper, label, optional, ...rest }: Props) => {
  const [dealers, setDealers] = useState([
    {
      label: 'loading...',
      value: '',
    },
  ])
  const name = 'dealer'

  useEffect(() => {
    async function getDealerList() {
      let list = await getDealers()
      list = list.map((dealer) => ({
        label: dealer._source.name.trim(),
        value: `${dealer._source.name.trim()} :: ${
          dealer._source.applications.NMSC.externalID
        }`,
      }))
      setDealers([...list])
    }
    getDealerList()
  }, [])

  return (
    <SelectInput
      name={name}
      label={label}
      options={dealers}
      helper={helper}
      optional={optional}
      {...rest}
    />
  )
}

export default Dealers
